import { render, staticRenderFns } from "./details.vue?vue&type=template&id=46cca8cf&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=46cca8cf&prod&lang=less&scoped=true&"
import style1 from "./details.vue?vue&type=style&index=1&id=46cca8cf&prod&lang=css&"
import style2 from "./details.vue?vue&type=style&index=2&id=46cca8cf&prod&lang=less&scoped=true&"
import style3 from "./details.vue?vue&type=style&index=3&id=46cca8cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cca8cf",
  null
  
)

export default component.exports